var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-services"},[_c('CarrouselPropio',{attrs:{"testimonios":_vm.testimonios}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }